import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'meterIdFilter',
  pure: false
})
export class MeterIdFilterPipe implements PipeTransform {
  public transform(items: any[], searchText: string): any {
    if (searchText === '' || items == null) {
      return items;
    }
    const found = items.filter(
      (item) => item.meterId.indexOf(searchText) !== -1
    );
    return found ? found : items;
  }
}
